/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import Auth from "../../shared/Auth";
import L from "../Lang"
import BaseCom from "../BaseCom";
import DataTable from "../DataTable";
import Icon from "../Icon";
import { SidebarGlobal } from "../_SidebarGlobal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Globals from "../../shared/Globals";

class SpecimenList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        }
    }

    async componentDidMount() {
        await this.getSettings();
        SidebarGlobal.setSubNav(<>
            <button className="btn btn-primary" onClick={() => this.props.navigate('/specimen/new')}>
                <Icon icon="faPlus" /> <span className="d-none d-md-inline"><L>New</L></span>
            </button>
        </>);
        Auth.getLogin(u => {
            this.setState({ user: u });
        });
        this.applyThemeColors();
        this.fillList('/api/specimen/list', 'list', true);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    onSort = () => {

    }

    render() {
        if (!this.state.list)
            return;
        const columns = [
            {
                name: 'sid', title: <><span className="d-none d-md-inline">{this.T('specimen')}</span><L>ID</L></>, sort: 'sid', valueFunc: row => {
                    return <Link to={'/specimen/' + row.id}>{row.sid}</Link>;
                }
            },
            {
                name: 'patientName', title: this.T('subject') + ' Name', sort: 'patientName', valueFunc: row => {
                    return <Link to={'/order/view/' + row.orderID}>{row.patientName} <span className="text-muted">({row.patientBirthDate})</span></Link>;
                }
            },
            {
                name: 'specimenTypeName', title: 'Specimen Type', sort: 'specimenTypeName',
                valueFunc: row => row.specimenTypeName ?? 'N/A',
                className: 'd-none d-md-table-cell'
            },
            {
                name: 'collectedDate', title: 'Collection Date', sort: 'collectedDate',
                valueFunc: row => {
                    return row.isCollected ? Globals.toMDYHMLocalDateStringOrDiff(row.collectedDate, true) : 'N/A';
                },
                className: 'd-none d-md-table-cell'
            },
            {
                name: 'status', title: 'Status', sort: 'status',
                className: 'd-none d-md-table-cell'
            }
        ];

        return <div className="container-fluid">
            <h1>{this.T('specimen')} List</h1>
            <DataTable columns={columns} data={this.state.list} totalCount={this.state.totalCount} headClassName="--bg-primary"
                loading={this.state.loading} onSort={this.onSort} showCheckboxes={this.state.showFilters} defaultSort="createdDate" defaultSortDesc
                sticky heightDelta="280" />
        </div>;
    }
}

export default withParamsAndNavigate(SpecimenList);